// assets/stz-datetime-picker.js
// Two birth-data intake upgrades (see the personalized product form):
//   1. Date inputs marked [data-stz-open-picker] open the native calendar when you click anywhere in
//      the field, not just the tiny icon.
//   2. <stz-time-picker> replaces the awkward native time input with a friendly inline Hour / Minute /
//      AM-PM control. The value is always visible (no popup, no "did it save"), and it writes the
//      standard properties[Birth Time] = HH:MM (24h) that the chart engine + the cart gate read.

// This file is a CLASSIC script (not a module) and it declares `StzTimePicker` at top level.
// Two different blocks can legitimately render a Birth Date field and a Birth Time field on the
// same personalized product page, so the tag can be emitted more than once - and a classic script
// evaluated twice throws `SyntaxError: Identifier 'StzTimePicker' has already been declared`
// before a single statement of the second copy runs. The `stz-datetime-picker-script` snippet stops
// the duplicate tag; this IIFE + load flag makes a second evaluation a harmless no-op even if one
// slips through.
(() => {
  if (window.__stzDatetimePickerLoaded) return;
  window.__stzDatetimePickerLoaded = true;

  // 1. click-to-open date pickers (delegated, so it works no matter when the field mounts).
  //    Guarded so loading this asset once per field does not attach the listener twice.
  if (!window.__stzDatetimePickerInit) {
    window.__stzDatetimePickerInit = true;
    document.addEventListener('click', (event) => {
      const el = event.target && event.target.closest && event.target.closest('[data-stz-open-picker]');
      if (el && typeof el.showPicker === 'function') { try { el.showPicker(); } catch (e) { /* not user-activated / unsupported */ } }
    });
  }

  // 2. inline Hour / Minute / AM-PM time picker
  class StzTimePicker extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.valueEl = this.querySelector('[data-time-value]');
      this.hourEl = this.querySelector('[data-time-hour]');
      this.minEl = this.querySelector('[data-time-min]');
      this.ampmBtns = Array.from(this.querySelectorAll('[data-time-ampm]'));
      this.ampm = '';
      this.hourEl && this.hourEl.addEventListener('change', () => this.sync());
      this.minEl && this.minEl.addEventListener('change', () => this.sync());
      this.ampmBtns.forEach((btn) => btn.addEventListener('click', () => {
        this.ampm = btn.dataset.timeAmpm;
        this.ampmBtns.forEach((b) => b.classList.toggle('is-active', b === btn));
        this.sync();
      }));
    }

    // hour(1-12) + minute(0-59) + AM/PM -> HH:MM (24h), written to the hidden Birth Time input
    sync() {
      const h = this.hourEl && this.hourEl.value;
      const m = this.minEl && this.minEl.value;
      let out = '';
      if (h && m !== '' && m != null && this.ampm) {
        let hr = parseInt(h, 10) % 12;
        if (this.ampm === 'PM') hr += 12;
        out = String(hr).padStart(2, '0') + ':' + String(parseInt(m, 10)).padStart(2, '0');
      }
      if (this.valueEl && this.valueEl.value !== out) {
        this.valueEl.value = out;
        this.valueEl.dispatchEvent(new Event('input', { bubbles: true }));
        this.valueEl.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }

  if (!customElements.get('stz-time-picker')) customElements.define('stz-time-picker', StzTimePicker);
})();
